import React from "react";

function PdfButtons() {

  const openPDF1 = () => {
    window.open("/images/pdf1.pdf", "_blank");
  };

  const openPDF2 = () => {
    window.open("/images/pdf2.pdf", "_blank");
  };

  return (
    <div style={{ textAlign: "center", margin: "30px" }}>

      <button onClick={openPDF1} style={btnStyle}>
        📄 PDF 1 पहा
      </button>

      <button onClick={openPDF2} style={btnStyle}>
        📄 PDF 2 पहा
      </button>

    </div>
  );
}

const btnStyle = {
  padding: "10px 20px",
  margin: "10px",
  background: "#0d3b66",
  color: "white",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer"
};

export default PdfButtons;